"use client";

import React from "react";

import { selectUserData, useAppSelector } from "@/services/Store";

import {
  StyledAvatar,
  StyledName,
  StyledUserDetailsContainer,
} from "./UserInfoDisplay.styles";
import RatingDisplay from "../RatingDisplay";

const UserInfoDisplay: React.FC<{ className?: string }> = ({ className }) => {
  const userData = useAppSelector(selectUserData);

  return (
    <StyledUserDetailsContainer className={className}>
      <StyledAvatar
        img={userData?.picture || userData?.owner_profile || ""}
        firstName={userData?.given_name || ""}
        lastName={userData?.family_name || ""}
      />
      <StyledName>
        {userData?.given_name || ""} {userData?.family_name || ""}
      </StyledName>
      <RatingDisplay className="mt-2" rating={4.9} reviewCount={354} />
    </StyledUserDetailsContainer>
  );
};

export default UserInfoDisplay;
